module.exports = __webpack_public_path__ + "img/library.a592bdf0.svg";